<template>
    <div class="tip-box">
      <div class="tip-pic">
        <slot name="tipPic"></slot>
      </div>
      <div class="tip-text">
        <slot name="tipText"></slot>
      </div>
      <div class="tip-btn">
        <slot name="tipBtn"></slot>
      </div>
    </div>
</template>

<script>
    export default {
        name: "EmptyDataTip"
    }
</script>

<style scoped>
  .tip-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center
  }
  .tip-pic img{
    display: block;
    width: 300px;
    height: auto;
  }
  .tip-text{
    font-size: 18px;
    color: #666;
    margin-top: 20px;
  }
</style>
